<template>
  <div
    v-if="!showUserDifficultyLabels"
    class="metadata-component-container"
  >
    <div>ANSWERED {{ metadata.totalAnswers }} TIMES</div>
    <div>{{ metadata.correctPercent }}% CORRECT</div>
  </div>
  <div
    v-else
    class="ab-metadata-component-container"
  >
    <div v-if="pValue">
      <small>
        <icon
          name="gauge"
          variant="7B7B7B"
        />
        <span>Difficulty</span>
      </small>
      <strong>{{ pValue }}</strong>
    </div>
    <div>
      <small>
        <icon
          name="avatar-group"
          variant="7B7B7B"
        />
        <span class="times-answered-label"></span>
      </small>
      <strong>{{ metadata.totalAnswers.toLocaleString('en-US') }}</strong>
    </div>
    <div>
      <small>
        <icon
          name="verified-check"
          variant="7B7B7B"
        />
        <span class="correct-answered-label"></span>
      </small>
      <strong>{{ metadata.correctPercent }}%</strong>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    metadata: {
      type: Object,
    },
  },
  data() {
    return {
      showUserDifficultyLabels: false,
    };
  },
  computed: {
    pValue() {
      if (this.metadata.difficulty) {
        const pValue = this.metadata.difficulty;
        if (pValue >= 0.8) {
          return 'Easy';
        } else if (pValue >= 0.7 && pValue < 0.8) {
          return 'Medium';
        } else if (pValue >= 0.5 && pValue < 0.7) {
          return 'Hard';
        } else if (pValue < 0.5) {
          return 'Challenge';
        }
      }
      return null;
    },
  },
  mounted() {
    this.setShowUserDifficultyLabels();
  },
  methods: {
    setShowUserDifficultyLabels() {
      let show = false;
      const user = this.$store.getters['user/get'];
      if (user?.previewer) {
        show = true;
      } else {
        const apptimizeEnabled = this.$apptimize.checkExperiments({
          experimentName: 'Enable Question Difficulty Labels',
          bool: 'enableQuestionDifficultyLabels',
          defaultVal: false,
          matcher: /Enable Question Difficulty Labels/,
        });
        show = apptimizeEnabled;
      }

      this.showUserDifficultyLabels = show;
    },
  },
};
</script>

<style lang="scss" scoped>
.metadata-component-container {
  font-size: rem-calc(11);
  font-weight: $semi-bold;
  letter-spacing: 1px;
  margin-left: auto;
  text-align: right;

  @include breakpoint(small) {
    font-size: rem-calc(13);
    margin-right: auto;
    margin-top: rem-calc(12);
    text-align: center;
  }

  > div:first-child {
    margin-bottom: rem-calc(4);
  }
}
.ab-metadata-component-container {
  display: flex;

  div {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    small {
      display: flex;
      align-items: center;
      font-size: rem-calc(10);
      font-weight: 400;
      line-height: rem-calc(10);
      color: #7B7B7B;
      img {
        height: rem-calc(13);
        width: rem-calc(13);
        padding-right: rem-calc(3);
      }
      // Changing the text displayed based on screen size by using CSS rather than adding a watcher in the business logic
      .times-answered-label:before {
        content: "Times Answered";
      }
      .correct-answered-label:before {
        content: "Correct Answer";
      }
    }
    strong {
      padding-top: rem-calc(6);
      font-size: rem-calc(14);
      font-weight: $semi-bold;
      line-height: rem-calc(16);
    }
  }

  @include breakpoint(small) {
    width: 100%;
    justify-content: space-between;
    div {
      flex: 1;
      border: 1px solid #E9E9E9;
      border-radius: rem-calc(4);
      // Changing the text displayed based on screen size by using CSS rather than adding a watcher in the business logic
      small {
        .times-answered-label:before {
          content: "Answered";
        }
        .correct-answered-label:before {
          content: "Correct";
        }
      }
      &:not(:first-child) {
        margin-left: rem-calc(4);
      }
    }
  }
}
</style>